import Vue from 'vue';
import { hasProp } from '@/utils/validate.utils';

const ADD_INSTALLATIONS = (state, installations) => {
  state.installations = installations;
};

const ADD_INSTALLATION = (state, { installationID, data }) => {
  Vue.set(state.installations, installationID, data);
};

const UPDATE_INSTALLATION = (state, { installationID, data }) => {
  Object.keys(data).forEach(key => {
    Vue.set(state.installations[installationID], key, data[key]);
  });
};

const DELETE_INSTALLATION = (state, installationID) => {
  Vue.delete(state.installations, installationID);
};

const ADD_DEVICE = (state, { installationID, deviceMac, data }) => {
  Vue.set(state.installations[installationID].devices, deviceMac, data);
};

const UPDATE_DEVICE = (state, { installationID, deviceMac, data }) => {
  // Existe un problema al inicializar la máquina después de un error de máquina,
  // en el que puede tardar un tiempo en enviar todos los datos,
  // y puede producirse una desincronización si el usuario interactua con la máquina en ese momento.
  // Para evitarlo, añadimos un delay de 4 segundos antes de aplicar el cambio de machineready,
  // para que puedan llegar todos los datos antes de que la zona esté activa
  if (
    hasProp(data, 'machineready') &&
    hasProp(state.installations[installationID].devices[deviceMac], 'machineready') &&
    data.machineready === true
  ) {
    const machineready = data.machineready;
    delete data.machineready;

    setTimeout(() => {
      Vue.set(state.installations[installationID].devices[deviceMac], 'machineready', machineready);
    }, 5000);
  }

  // Almaceno los cambios
  Object.keys(data).forEach(key => {
    Vue.set(state.installations[installationID].devices[deviceMac], key, data[key]);
  });
};

const DELETE_DEVICE = (state, { installationID, deviceMac }) => {
  Vue.delete(state.installations[installationID].devices, deviceMac);
};

const ADD_SCHEDULE = (state, { installationID, scheduleID, data }) => {
  Vue.set(state.installations[installationID].schedules, scheduleID, data);
};

const UPDATE_SCHEDULE = (state, { installationID, scheduleID, data }) => {
  Object.keys(data).forEach(key => {
    Vue.set(state.installations[installationID].schedules[scheduleID], key, data[key]);
  });
};

const DELETE_SCHEDULE = (state, { installationID, scheduleID }) => {
  Vue.delete(state.installations[installationID].schedules, scheduleID);
};

const ADD_SCENE = (state, { installationID, sceneID, data }) => {
  Vue.set(state.installations[installationID].scenes, sceneID, data);
  state.installations[installationID].scenesOrder.push(sceneID);
};

const UPDATE_SCENE = (state, { installationID, sceneID, data }) => {
  Object.keys(data).forEach(key => {
    Vue.set(state.installations[installationID].scenes[sceneID], key, data[key]);
  });
};

const DELETE_SCENE = (state, { installationID, sceneID }) => {
  const newScenesOrder = state.installations[installationID].scenesOrder.filter(
    sceneItem => sceneItem !== sceneID
  );

  Vue.set(state.installations[installationID], 'scenesOrder', newScenesOrder);
  Vue.delete(state.installations[installationID].scenes, sceneID);
};

const UPDATE_LIST_SCENES = (state, { installationID, listScenes }) => {
  Vue.set(state.installations[installationID].scenesOrder, listScenes);
};

const ADD_WEATHER = (state, { installationID, data }) => {
  Vue.set(state.installations[installationID], 'weather', data);
};

export default {
  ADD_INSTALLATIONS,
  ADD_INSTALLATION,
  UPDATE_INSTALLATION,
  DELETE_INSTALLATION,
  ADD_DEVICE,
  UPDATE_DEVICE,
  DELETE_DEVICE,
  ADD_SCHEDULE,
  UPDATE_SCHEDULE,
  DELETE_SCHEDULE,
  ADD_SCENE,
  UPDATE_SCENE,
  DELETE_SCENE,
  UPDATE_LIST_SCENES,
  ADD_WEATHER,
};
